module.exports = __webpack_public_path__ + "static/img/bg25.389ca234.png";